import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';

// 脉冲动画
const pulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 3px 8px rgba(78, 205, 196, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
`;

// 按钮样式
const RulesButton = styled.div`
  font-size: 16px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 6px 10px;
  gap: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  border: 1px solid #e0e0e0;
  
  &:hover {
    background-color: #e9e9e9;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
`;

// 问号图标样式
const QuestionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: #4ECDC4;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

interface GameRulesButtonProps {
  className?: string;
  onToggleGameRules: (isOpen: boolean) => void;
}

const GameRulesButton: React.FC<GameRulesButtonProps> = ({ className, onToggleGameRules }) => {
  const { t } = useTranslation();
  const openModal = () => {
    onToggleGameRules(true);
  };

  return (
    <>
      <RulesButton onClick={openModal} className={className}>
        <span>{t('rules.title')}</span>
        <QuestionIcon>?</QuestionIcon>
      </RulesButton>
    </>
  );
};

export default GameRulesButton; 